import { Box } from '@mui/material';
import LoadingOverlay from './loadingOverlay';

type FormLoaderWrapperProps = {
  loading: boolean;
  children: JSX.Element;
};

const FormLoaderWrapper = (props: FormLoaderWrapperProps) => {
  const { loading, children } = props;

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <LoadingOverlay loading={loading} />
      {children}
    </Box>
  );
};

export default FormLoaderWrapper;
